import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';

import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner'
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { HttpRequestInterceptor } from './utils/httpRequest.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { dataServiceInterceptor } from './interceptors/data-service.interceptor';
import { apiMigrationDebugInterceptor } from './interceptors/api-migration-debug.interceptor';
import { LoggerModule } from 'ngx-logger';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([
      dataServiceInterceptor,
      ...(!environment.production ? [apiMigrationDebugInterceptor] : [])
    ])),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi:true
    },
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      ToastrModule.forRoot({
        timeOut:5000,
        positionClass: 'toast-bottom-right',
        preventDuplicates: true
      }),
      NgxSpinnerModule.forRoot({type: 'ball-scale-multiple'}),
      LoggerModule.forRoot({ level: environment.logLevel })
    )
  ]
};
